import React, { memo } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";

// FEATURE_FLAG names are first defined in .env
export enum FEATURE_FLAG {
  CASHIER_INSTRUCTIONS = "CASHIER_INSTRUCTIONS",
  MULTI_MECHANIC = "MULTI_MECHANIC",
  MECHANISM_TITLE_TEXT = "MECHANISM_TITLE_TEXT",
  AM_RECEIPTS = "AM_RECEIPTS",
  RETAILER_GROUP = "RETAILER_GROUP",
  USAGE_LIMIT = "USAGE_LIMIT",
  NEW_OFFER_TEMPLATE = "NEW_OFFER_TEMPLATE",
  SKIP_MILES_AWARD_TYPES = "SKIP_MILES_AWARD_TYPES"
}

interface IFeatureFlagProps {
  featureName: FEATURE_FLAG;
  children: any;
}

const launchDarklyFlagState: Partial<Record<FEATURE_FLAG, boolean | string>> = {};

export const LaunchDarklyFlagSync: React.FunctionComponent = () => {
  const flags = useFlags();

  Object.assign(launchDarklyFlagState, flags);

  return null;
};

const getFeatureFlagValue = (featureName: FEATURE_FLAG) => {
  const launchDarklyValue = launchDarklyFlagState[featureName];

  if (typeof launchDarklyValue !== "undefined") {
    return launchDarklyValue;
  }

  return process.env["REACT_APP_" + featureName];
};

export const FeatureFlag: React.FunctionComponent<IFeatureFlagProps> = memo((props) => {
  const { featureName, children } = props;

  if (getFeatureFlagValue(featureName) === false || getFeatureFlagValue(featureName) === "false") {
    return <></>;
  }

  return <>{children}</>;
});

export const featureFlagCompare = (flag: FEATURE_FLAG, compareValue: String) => {
  return String(getFeatureFlagValue(flag)) === compareValue;
}
